import { Component } from "@angular/core";
import { ModalService } from "@app/services/modal.service";

@Component({
  selector: "app-modal-non-payment-error",
  templateUrl: "./modal-non-payment-error.component.html",
  styleUrls: ["./modal-non-payment-error.component.scss"],
})
export class ModalNonPaymentErrorComponent {
  constructor(public modal: ModalService) {}

  ngOnDestroy() {
    this.modal.close();
  }

  goToStart() {
    this.modal.close();
  }
}
